'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./MountainForeground.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MountainForeground = function MountainForeground(_ref) {
    var className = _ref.className;
    return _react2.default.createElement(
        'svg',
        { className: (0, _classnames2.default)("mountain-foreground-comp", className),
            x: '0px',
            y: '0px',
            viewBox: '0 0 569.4 363.1' },
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { className: 'lil-dude', d: 'M301.3,15.4c4.2,0,7.7-3.5,7.7-7.7S305.6,0,301.3,0c-4.2,0-7.7,3.5-7.7,7.7S297.1,15.4,301.3,15.4z'
            }),
            _react2.default.createElement('path', { className: 'lil-dude', d: 'M326,7.7L324.8,6c-0.9-0.7-1.9-0.7-2.7-0.1l-15.9,11.4h-9.8L280.5,5.8c-0.8-0.5-1.8-0.5-2.7,0.1l-1.2,1.7 c-0.7,1-0.4,2.3,0.5,3l16,11.5v18.7v0.4v23.1c0,0.6,0.5,1.2,1.2,1.2h5c0.6,0,1.2-0.5,1.2-1.2v-21h1.5v21c0,0.6,0.5,1.2,1.2,1.2 h5c0.6,0,1.2-0.5,1.2-1.2V41.1v-0.4V22.1l16-11.5C326.4,10,326.7,8.6,326,7.7z'
            })
        ),
        _react2.default.createElement('path', { className: 'lil-dude-shorts', d: 'M310.1,39.2c-0.5,0.1-1-0.1-1.4-0.1c-5.3,0-10.7-0.6-16-0.2l-3.3,19.3h11.2l0.7-11.4l0.8,11.4h11L310.1,39.2 z'
        }),
        _react2.default.createElement('path', { className: 'lil-dude-shorts', d: 'M308.6,39.2c0.4,0,1,0.1,1.4,0.1l-0.6-3.7h-16.2l-0.6,3.5C297.9,38.5,303.4,39.2,308.6,39.2z'
        }),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { className: 'lil-dude-belt-buckle', d: 'M297.1,38.3c0.4,0,1-0.3,1-0.8c0-0.8-1.3-0.6-1.3-0.9c0-0.1,0.1-0.2,0.3-0.2c0.2,0,0.5,0.1,0.7,0.2 l0.3-0.4c-0.2-0.2-0.5-0.3-0.9-0.3c-0.6,0-0.9,0.4-0.9,0.7c0,0.9,1.3,0.6,1.3,0.9c0,0.1-0.1,0.2-0.3,0.2 c-0.3,0-0.6-0.1-0.7-0.3l-0.3,0.5C296.3,38.2,296.9,38.3,297.1,38.3z'
            }),
            _react2.default.createElement('rect', { x: '303.4', y: '36', className: 'lil-dude-belt-buckle', width: '0.6', height: '2.3'
            }),
            _react2.default.createElement('path', { className: 'lil-dude-belt-buckle', d: 'M305.5,37H305v-0.5h0.5c0.2,0,0.3,0.1,0.3,0.3C305.8,36.9,305.7,37,305.5,37z M306.4,38.3l-0.5-0.9 c0.2-0.1,0.4-0.3,0.4-0.7s-0.3-0.8-0.8-0.8h-1.2v2.3h0.6v-0.8h0.3l0.4,0.8h0.8V38.3z'
            }),
            _react2.default.createElement('path', { className: 'lil-dude-belt-buckle', d: 'M300.3,36.4c-0.1-0.2-0.5-0.4-0.8-0.4c-0.7,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.3,1.2,1.3 c1.1,0,1.4-1.1,1.7-1.5c0.2-0.2,0.3-0.4,0.6-0.4c0.4,0,0.6,0.3,0.6,0.7s-0.3,0.6-0.7,0.6c-0.2,0-0.6-0.2-0.7-0.3l-0.3,0.4 c0.1,0.1,0.4,0.5,0.9,0.5c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.3-1.2-1.3c-1.3,0-1.2,1.8-2.3,1.8c-0.4,0-0.7-0.3-0.7-0.7 c0-0.5,0.4-0.7,0.7-0.8C299.7,36.3,300.1,36.3,300.3,36.4L300.3,36.4z'
            })
        ),
        _react2.default.createElement('path', { className: 'rocks', d: 'M519.8,129.6c0,0-25.8-32-32-25.8s-13.5,12.5-13.5,12.5s-28.3-53.9-48-46.1c-19.7,7.7-32,26.2-49.2,17.6 s-25.8-12.3-40.6-12.3c-14.8,0-30.8-46.8-73.8-28.3s-59.1,28.8-93.5,23c-34.5-5.8-57.8,5.3-94.8,33.6S0.5,129.6,0.5,129.6H519.8z'
        }),
        _react2.default.createElement('path', { className: 'rocks-submerged', d: 'M519.8,129.7c0,0-25.8,30.6-32,24.7c-6.2-5.9-13.5-12-13.5-12s-28.3,51.5-48,44.1s-32-25.1-49.2-16.8 c-17.2,8.2-25.8,11.8-40.6,11.8c-14.8,0-30.8,44.8-73.8,27.1s-59.1-27.6-93.5-22c-34.5,5.5-57.8-5.1-94.8-32.1 S0.5,129.7,0.5,129.7H519.8z'
        })
    );
};
MountainForeground.propTypes = {
    className: _propTypes2.default.string
};
exports.default = MountainForeground;
//# sourceMappingURL=MountainForeground.js.map